import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "outRole",
  "use": "outRole-usage",
  "viewBox": "0 0 11.07 8.15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.07 8.15\" id=\"outRole\"><title>22</title><path d=\"M10.89 2.28L5.64.02a.25.25 0 0 0-.2 0L.19 2.28a.34.34 0 0 0 0 .61l5.25 2.26a.25.25 0 0 0 .2 0L9.72 3.4v1.8a.77.77 0 0 0 0 1.32v.63h.54v-.64a.77.77 0 0 0 0-1.32v-2l.63-.27a.34.34 0 0 0 0-.61zM5.54 5.59a.58.58 0 0 1-.24-.08L2.07 4.14v1.94c0 1.59 2.39 2.07 3.13 2.07h.75c.56 0 3.13-.48 3.13-2.07V4.14L5.77 5.51a.57.57 0 0 1-.23.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/outRole.svg
// module id = jxzN
// module chunks = 6